<div class="container-fluid">
    <div class="row">
        <div class="page-heading">
            <div class="page-title">
                <h2>{{ titleKey | translate }}</h2>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-9">
            <p *ngIf="loading else data_loaded" class="loading-text">
                {{ 'common.loading' | translate }} ...
            </p>
            <ng-template #data_loaded>
                <div class="order-detail">

                    <div class="text-end mb-3">
                        <a [routerLink]="['/user', user.id, 'orders']" class="btn btn-success order-back-btn">
                            <i class="fa fa-arrow-left me-2"></i>{{ 'common.back' | translate }}
                        </a>
                    </div>

                    <div class="order-header-card">
                        <div class="order-header-row">
                            <div class="order-header-item">
                                <span class="header-label">{{ 'orders_list.ref' | translate }}</span>
                                <span class="header-value">#{{ order.orderNumber }}</span>
                            </div>
                            <div class="order-header-item">
                                <span class="header-label">{{ 'common.status' | translate }}</span>
                                <span [class]="getStatusClass(order.status)">{{ order.status }}</span>
                            </div>
                            <div class="order-header-item">
                                <span class="header-label">{{ 'orders_list.ordered_at' | translate }}</span>
                                <span class="header-value">{{ formatDate(order.createdAt) }}</span>
                            </div>
                            <div class="order-header-item" *ngIf="order.payment">
                                <span class="header-label">{{ 'common.payment_method' | translate }}</span>
                                <span class="header-value">{{ getPaymentMethodLabel(order.payment.paymentMethod) }}</span>
                            </div>
                            <div class="order-header-item" *ngIf="order.payment">
                                <span class="header-label">{{ 'common.amount' | translate }}</span>
                                <span class="header-value amount">{{ formatCurrency(order.payment.amount, order.payment.currency) }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="line-items" *ngIf="lineOffers?.length > 0">
                        <div class="line-item-card" *ngFor="let lineOffer of lineOffers">
                            <div class="line-item-header" (click)="toggleLineOffer(lineOffer)">
                                <div class="line-item-body">
                                    <div class="line-item-image" *ngIf="productPictureUrl(lineOffer)">
                                        <img [src]="productPictureUrl(lineOffer)" [alt]="getProductName(lineOffer)">
                                    </div>
                                    <div class="line-item-image" *ngIf="!productPictureUrl(lineOffer)">
                                        <div class="no-image">
                                            <i class="fa fa-image fa-2x text-muted"></i>
                                        </div>
                                    </div>
                                    <div class="line-item-info">
                                        <h5 class="product-name">{{ getProductName(lineOffer) }}</h5>
                                        <div class="product-meta">
                                            <span class="meta-badge" *ngIf="getConditionDescription(lineOffer)">
                                                {{ getConditionDescription(lineOffer) }}
                                            </span>
                                            <span class="meta-badge" *ngIf="getMeasurementDescription(lineOffer)">
                                                {{ getMeasurementDescription(lineOffer) }}
                                            </span>
                                            <span class="meta-badge" *ngIf="getCategoryName(lineOffer)">
                                                {{ getCategoryName(lineOffer) }}
                                            </span>
                                            <span class="meta-badge meta-badge-pickup" *ngIf="lineOffer.localPickup">
                                                <i class="fa fa-hand-holding me-1"></i> {{ 'delivery.local_pickup_option' | translate }}
                                            </span>
                                        </div>
                                        <div class="seller-row" *ngIf="getSellerName(lineOffer)">
                                            <span class="seller-label">{{ 'common.seller' | translate }}:</span>
                                            <span class="seller-name">{{ getSellerName(lineOffer) }}</span>
                                        </div>
                                        <div class="logistics-row" *ngIf="lineOffer.localPickup">
                                            <span class="delivery-status" [class]="'status-' + lineOffer.status?.toLowerCase()">
                                                <i class="fa fa-box-open me-1"></i> Pickup: {{ 'sales.status_' + lineOffer.status?.toLowerCase() | translate }}
                                            </span>
                                        </div>
                                        <div class="logistics-row" *ngIf="lineOffer.logisticInfo?.deliveringRef && lineOffer.logisticInfo?.logisticAgent">
                                            <div class="delivery-status" [class]="'status-' + getDeliveryStatusRaw(lineOffer)?.toLowerCase()">
                                                <i class="fa fa-truck me-1"></i>
                                                {{ 'delivery.title' | translate }}: {{ getDeliveryStatus(lineOffer) | translate }}
                                            </div>
                                            <div class="delivery-address" *ngIf="deliveryAddressString(lineOffer)">
                                                <i class="fa fa-map-marker-alt me-1 text-muted"></i>
                                                {{ deliveryAddressString(lineOffer) }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="line-item-price">
                                        <div class="price-row">
                                            <span class="price-label">{{ 'common.unit_price' | translate }}: </span>
                                            <span class="unit-price">{{ formatCurrency(getDiscountedPrice(lineOffer)) }}</span>
                                            <span class="text-muted" *ngIf="lineOffer.discount > 0">
                                                <del class="original-price">{{ formatCurrency(lineOffer.price) }}</del>
                                            </span>
                                        </div>
                                        <div class="price-row">
                                            <span class="price-label">{{ 'common.quantity' | translate }}: </span>
                                            <span class="price-value">{{ lineOffer.qty }}</span>
                                        </div>
                                    </div>
                                    <div class="chevron" [class.rotated]="expandedLineOfferId === lineOffer.id">
                                        <span class="chevron-label">
                                            {{ expandedLineOfferId === lineOffer.id ? ('order.hide_details' | translate) : ('order.show_details' | translate) }}
                                        </span>
                                        <i class="fa fa-chevron-down"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="line-item-detail" *ngIf="expandedLineOfferId === lineOffer.id">
                                <div *ngIf="loadingLineOffer" class="text-center py-3">
                                    <div class="spinner-border spinner-border-sm text-success" role="status"></div>
                                </div>
                                <div *ngIf="!loadingLineOffer && lineOfferDetail && lineOfferDetail.logisticInfo?.logisticAgent" class="detail-content">
                                    <h6 class="detail-section-title">{{ 'tracking.title' | translate }}</h6>
                                    <div class="tracking-timeline">
                                        <div class="timeline-steps">
                                            <div class="timeline-step"
                                                 *ngFor="let step of getDeliverySteps(); let i = index; let last = last"
                                                 [class.completed]="i < getCurrentDeliveryStepIndex(lineOffer)"
                                                 [class.active]="i === getCurrentDeliveryStepIndex(lineOffer)">
                                                <div class="step-dot">
                                                    <i class="fa fa-check" *ngIf="i < getCurrentDeliveryStepIndex(lineOffer)"></i>
                                                </div>
                                                <div class="step-label">{{ step.labelKey | translate }}</div>
                                                <div class="step-line" *ngIf="!last"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="detail-section">
                                        <div class="logistics-item" *ngIf="lineOfferDetail.logisticInfo.logisticAgent">
                                            <span>{{ 'order.logistic_agent' | translate }}: <strong>{{ lineOfferDetail.logisticInfo.logisticAgent }}</strong></span>
                                        </div>
                                        <div class="logistics-item" *ngIf="deliveryAddressString(lineOfferDetail)">
                                            <span>{{ deliveryAddressString(lineOfferDetail) }}</span>
                                        </div>
                                        <div class="logistics-item" *ngIf="lineOfferDetail.logisticInfo.deliveringRef">
                                            <span>{{ 'order.delivery_ref' | translate }}: {{ lineOfferDetail.logisticInfo.deliveringRef }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div *ngIf="!loadingLineOffer && lineOfferDetail && lineOfferDetail.logisticInfo && !lineOfferDetail.logisticInfo.logisticAgent" class="detail-content pickup-info">
                                    <i class="fa fa-box-open me-2 text-muted"></i>
                                    <span>{{ 'order.pickup_at' | translate }} <strong>{{ deliveryAddressString(lineOfferDetail) }}</strong></span>
                                </div>
                                <div *ngIf="!loadingLineOffer && lineOfferDetail && !lineOfferDetail.logisticInfo" class="detail-content no-tracking">
                                    {{ 'order.no_delivery_option' | translate }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="order-summary-card" *ngIf="lineOffers?.length > 0">
                        <div class="summary-row">
                            <span class="summary-label">{{ 'orders_list.ref' | translate }}</span>
                            <span class="summary-value">#{{ order.orderNumber }}</span>
                        </div>
                        <div class="summary-row summary-total" *ngIf="order.payment">
                            <span class="summary-label">{{ 'common.total' | translate }}</span>
                            <span class="summary-value">{{ formatCurrency(order.payment.amount, order.payment.currency) }}</span>
                        </div>
                    </div>

                </div>
            </ng-template>
        </div>
        <div class="col-md-3">
            <app-sidebar [currentUser]="user"></app-sidebar>
        </div>
    </div>
</div>